import { t } from '@lingui/macro';
import { usePlai } from '../../PlaiProvider';
import { Feedback } from '../Feedback';
import { Section } from '../Section';
export function OpenedFeedback() {
    const { review } = usePlai();
    const { feedbacks = [] } = review || {};
    const openedFeedbacks = feedbacks.filter(f => !f.feedback.discarded);
    if (openedFeedbacks.length < 1) {
        return null;
    }
    return (<Section title={t({ comment: 'Plai Drawer - Opened issues section - title', message: 'Issues' })}>
      {openedFeedbacks.map(feedbackBundle => (<Feedback key={feedbackBundle.feedback.id} feedback={feedbackBundle}/>))}
    </Section>);
}
